module.exports = __webpack_public_path__ + "img/model_300.fd46105d.jpg";